import React from "react";

export default function CitationList({ citations }) {
  return (
    <section className="citation-panel info-panel">
      <div className="section-kicker">Evidence</div>
      <h2>Retrieved passages</h2>
      <div className="citation-list">
        {citations.length === 0 ? (
          <p className="answer-placeholder">No citations yet.</p>
        ) : (
          citations.map((citation) => (
            <article key={`${citation.document_id}-${citation.score}`} className="citation-item">
              <div className="citation-score">{Math.round(citation.score * 100)}%</div>
              <div>
                <div className="citation-doc">{citation.document_id}</div>
                <p>{citation.snippet}</p>
              </div>
            </article>
          ))
        )}
      </div>
    </section>
  );
}
